export default [
  {
    path: '/pengajuan-sidang/baru',
    name: 'pengajuan-sidang-baru',
    component: () => import('@/views/pages/pengajuan-sidang-baru/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'create',
    },
  },
  {
    path: '/pengajuan-sidang/edit/:uuid',
    name: 'pengajuan-sidang-edit',
    component: () => import('@/views/pages/pengajuan-sidang/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'edit',
    },
  },
  {
    path: '/pengajuan-sidang/readonly/:uuid',
    name: 'pengajuan-sidang-readonly',
    component: () => import('@/views/pages/pengajuan-sidang-readonly/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'readonly',
    },
  },
  {
    path: '/rekapitulasi-hasil',
    name: 'rekapitulasi-hasil',
    component: () => import('@/views/pages/rekapitulasi-hasil/list/List.vue'),
    meta: {
      resource: 'rekapitulasi-hasil',
      action: 'read',
    },
  },
  {
    path: '/daftar-sidang',
    name: 'list-sidang',
    component: () => import('@/views/pages/daftar-sidang/list/List.vue'),
    meta: {
      resource: 'daftar-list-sidang',
      action: 'read',
    },
  },
  {
    path: '/jadwal-sidang',
    name: 'jadwal-sidang',
    component: () => import('@/views/pages/jadwal-sidang/list/List.vue'),
    meta: {
      resource: 'jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/jadwal-sidang/:uuid',
    name: 'jadwal-sidang-edit',
    component: () => import('@/views/pages/jadwal-sidang/edit/Edit.vue'),
    meta: {
      resource: 'all-content',
      action: 'manage',
    },
  },
  {
    path: '/surat-tugas',
    name: 'surat-tugas',
    component: () => import('@/views/pages/surat-tugas/list/List.vue'),
    meta: {
      resource: 'surat-tugas',
      action: 'read',
    },
  },
  {
    path: '/surat-tugas-pembimbing',
    name: 'surat-tugas-pembimbing',
    component: () => import('@/views/pages/surat-tugas-pembimbing/list/List.vue'),
    meta: {
      resource: 'surat-tugas-pembimbing',
      action: 'read',
    },
  },
  {
    path: '/sktmt',
    name: 'sktmt',
    component: () => import('@/views/pages/sktmt/list/List.vue'),
    meta: {
      resource: 'sktmt',
      action: 'read',
    },
  },
  {
    path: '/notifikasi-email',
    name: 'notifikasi-email',
    component: () => import('@/views/pages/notifikasi-email/list/List.vue'),
    meta: {
      resource: 'notifikasi-email',
      action: 'read',
    },
  },
  {
    path: '/notifikasi-email/:uuid',
    name: 'notifikasi-email-edit',
    component: () => import('@/views/pages/notifikasi-email/edit/Edit.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },
  {
    path: '/hasil-sidang',
    name: 'hasil-sidang',
    component: () => import('@/views/pages/hasil-sidang/list/List.vue'),
    meta: {
      resource: 'hasil-sidang',
      action: 'read',
    },
  },
  {
    path: '/hasil-sidang-edit/:uuid',
    name: 'hasil-sidang-edit',
    component: () => import('@/views/pages/hasil-sidang/tab/Tab.vue'),
    meta: {
      resource: 'hasil-sidang',
      action: 'edit',
    },
  },
  {
    path: '/hasil-sidang-edit/perubahan-nilai/:uuid',
    name: 'hasil-sidang-perubahan-nilai-edit',
    component: () => import('@/views/pages/hasil-sidang/perubahan-nilai/Tab.vue'),
    meta: {
      resource: 'hasil-sidang',
      action: 'edit-perubahan-nilai',
    },
  },
  {
    path: '/pengguna',
    name: 'pengguna',
    component: () => import('@/views/pages/pengguna/list/List.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/pengguna-daftar-baru',
    name: 'pengguna-daftar-baru',
    component: () => import('@/views/pages/pengguna-daftar-baru/list/List.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/pengguna-edit/:id',
    name: 'pengguna-edit',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/hak-akses',
    name: 'hak-akses',
    component: () => import('@/views/pages/rules/list/List.vue'),
    meta: {
      resource: 'hak-akses',
      action: 'read',
    },
  },
  {
    path: '/hak-akses/edit/:id',
    name: 'hak-akses-edit',
    component: () => import('@/views/pages/rules/edit/Edit.vue'),
    meta: {
      resource: 'hak-akses',
      action: 'edit',
    },
  },
  {
    path: '/dosen',
    name: 'dosen',
    component: () => import('@/views/pages/dosen/list/List.vue'),
    meta: {
      resource: 'dosen',
      action: 'read',
    },
  },
  {
    path: '/dosen/:uuid',
    name: 'dosen-edit',
    component: () => import('@/views/pages/dosen/edit/Edit.vue'),
    meta: {
      resource: 'dosen',
      action: 'read',
    },
  },
  {
    path: '/jenjang',
    name: 'jenjang',
    component: () => import('@/views/pages/jenjang/list/List.vue'),
    meta: {
      resource: 'jenjang',
      action: 'read',
    },
  },
  {
    path: '/jenjang/:uuid',
    name: 'jenjang-edit',
    component: () => import('@/views/pages/jenjang/edit/Edit.vue'),
    meta: {
      resource: 'jenjang',
      action: 'read',
    },
  },
  {
    path: '/prodi',
    name: 'prodi',
    component: () => import('@/views/pages/prodi/list/List.vue'),
    meta: {
      resource: 'prodi',
      action: 'read',
    },
  },
  {
    path: '/import-peserta',
    name: 'import-peserta',
    component: () => import('@/views/pages/import-peserta/list/List.vue'),
    meta: {
      resource: 'import-peserta',
      action: 'read',
    },
  },
  {
    path: '/pengumuman-crud',
    name: 'pengumuman-crud',
    component: () => import('@/views/pages/pengumuman-crud/list/List.vue'),
    meta: {
      resource: 'pengumuman-crud',
      action: 'read',
    },
  },
  {
    path: '/pengumuman-crud/:uuid',
    name: 'pengumuman-crud-edit',
    component: () => import('@/views/pages/pengumuman-crud/edit/Edit.vue'),
    meta: {
      resource: 'pengumuman-crud',
      action: 'update',
    },
  },
  {
    path: '/soal-crud',
    name: 'soal-crud',
    component: () => import('@/views/pages/soal-crud/list/List.vue'),
    meta: {
      resource: 'soal-crud',
      action: 'read',
    },
  },
  {
    path: '/soal-crud/:uuid',
    name: 'soal-crud-edit',
    component: () => import('@/views/pages/soal-crud/edit/Edit.vue'),
    meta: {
      resource: 'soal-crud',
      action: 'update',
    },
  },
  {
    path: '/import-soal',
    name: 'import-soal',
    component: () => import('@/views/pages/import-soal/list/List.vue'),
    meta: {
      resource: 'import-soal',
      action: 'read',
    },
  },
  {
    path: '/prodi/:uuid',
    name: 'prodi-edit',
    component: () => import('@/views/pages/prodi/edit/Edit.vue'),
    meta: {
      resource: 'prodi',
      action: 'read',
    },
  },
  {
    path: '/peminatan',
    name: 'peminatan',
    component: () => import('@/views/pages/peminatan/list/List.vue'),
    meta: {
      resource: 'peminatan',
      action: 'read',
    },
  },
  {
    path: '/peminatan/:uuid',
    name: 'peminatan-edit',
    component: () => import('@/views/pages/peminatan/edit/Edit.vue'),
    meta: {
      resource: 'peminatan',
      action: 'read',
    },
  },
  {
    path: '/program',
    name: 'program',
    component: () => import('@/views/pages/program/list/List.vue'),
    meta: {
      resource: 'program',
      action: 'read',
    },
  },
  {
    path: '/program/:uuid',
    name: 'program-edit',
    component: () => import('@/views/pages/program/edit/Edit.vue'),
    meta: {
      resource: 'program',
      action: 'read',
    },
  },
  {
    path: '/ruangan',
    name: 'ruangan',
    component: () => import('@/views/pages/ruangan/list/List.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/ruangan/:uuid',
    name: 'ruangan-edit',
    component: () => import('@/views/pages/ruangan/edit/Edit.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/waktu-ujian',
    name: 'waktu-ujian',
    component: () => import('@/views/pages/waktu-ujian/list/List.vue'),
    meta: {
      resource: 'waktu-ujian',
      action: 'read',
    },
  },
  {
    path: '/waktu-ujian/:uuid',
    name: 'waktu-ujian-edit',
    component: () => import('@/views/pages/waktu-ujian/edit/Edit.vue'),
    meta: {
      resource: 'waktu-ujian',
      action: 'read',
    },
  },
  {
    path: '/status-hasil-sidang',
    name: 'status-hasil-sidang',
    component: () => import('@/views/pages/status-hasil-sidang/list/List.vue'),
    meta: {
      resource: 'status-hasil-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-hasil-sidang/:uuid',
    name: 'status-hasil-sidang-edit',
    component: () => import('@/views/pages/status-hasil-sidang/edit/Edit.vue'),
    meta: {
      resource: 'status-hasil-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-jadwal-sidang',
    name: 'status-jadwal-sidang',
    component: () => import('@/views/pages/status-jadwal-sidang/list/List.vue'),
    meta: {
      resource: 'status-jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-jadwal-sidang/:uuid',
    name: 'status-jadwal-sidang-edit',
    component: () => import('@/views/pages/status-jadwal-sidang/edit/Edit.vue'),
    meta: {
      resource: 'status-jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-pengajuan-sidang',
    name: 'status-pengajuan-sidang',
    component: () => import('@/views/pages/status-pengajuan-sidang/list/List.vue'),
    meta: {
      resource: 'status-pengajuan-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-pengajuan-sidang/:uuid',
    name: 'status-pengajuan-sidang-edit',
    component: () => import('@/views/pages/status-pengajuan-sidang/edit/Edit.vue'),
    meta: {
      resource: 'status-pengajuan-sidang',
      action: 'read',
    },
  },
  {
    path: '/proses-persidangan',
    name: 'proses-persidangan',
    component: () => import('@/views/pages/proses-persidangan/list/List.vue'),
    meta: {
      resource: 'proses-persidangan',
      action: 'read',
    },
  },
  {
    path: '/proses-persidangan/:uuid',
    name: 'proses-persidangan-edit',
    component: () => import('@/views/pages/proses-persidangan/edit/Edit.vue'),
    meta: {
      resource: 'proses-persidangan',
      action: 'read',
    },
  },
  {
    path: '/sync-dosen',
    name: 'sync-dosen',
    component: () => import('@/views/pages/sync-dosen/list/List.vue'),
    meta: {
      resource: 'sync-dosen',
      action: 'read',
    },
  },
  {
    path: '/list-peserta',
    name: 'list-peserta',
    component: () => import('@/views/pages/list-peserta/list/List.vue'),
    meta: {
      resource: 'list-peserta',
      action: 'read',
    },
  },
  {
    path: '/jadwal-ujian',
    name: 'jadwal-ujian',
    component: () => import('@/views/pages/jadwal-ujian/list/List.vue'),
    meta: {
      resource: 'jadwal-ujian',
      action: 'read',
    },
  },
  {
    path: '/jadwal-ujian/:uuid',
    name: 'jadwal-ujian-edit',
    component: () => import('@/views/pages/jadwal-ujian/edit/Edit.vue'),
    meta: {
      resource: 'jadwal-ujian',
      action: 'read',
    },
  },
  {
    path: '/jadwal-wawancara',
    name: 'jadwal-wawancara',
    component: () => import('@/views/pages/jadwal-wawancara/list/List.vue'),
    meta: {
      resource: 'jadwal-wawancara',
      action: 'read',
    },
  },
  {
    path: '/jadwal-wawancara/:uuid',
    name: 'jadwal-wawancara-edit',
    component: () => import('@/views/pages/jadwal-wawancara/edit/Edit.vue'),
    meta: {
      resource: 'jadwal-wawancara',
      action: 'read',
    },
  },
  {
    path: '/nilai-calon-peserta',
    name: 'nilai-calon-peserta',
    component: () => import('@/views/pages/nilai-calon-peserta/list/List.vue'),
    meta: {
      resource: 'nilai-calon-peserta',
      action: 'read',
    },
  },
  {
    path: '/form-perekomendasi/:tipe/:token',
    name: 'form-perekomendasi',
    component: () => import('@/views/pages/perekomendasi/FormWizard.vue'),
    meta: {
      resource: 'form-perekomendasi',
      action: 'read',
    },
  },
  {
    path: '/form-pewawancara/:tipe/:token',
    name: 'form-pewawancara',
    component: () => import('@/views/pages/pewawancara/FormWizard.vue'),
    meta: {
      resource: 'form-pewawancara',
      action: 'read',
    },
  },
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
  },

  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: '/apps/email',
    name: 'apps-email',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  {
    path: '/apps/email/:folder',
    name: 'apps-email-folder',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)) next()
      else next({ name: 'error-404' })
    },
  },
  {
    path: '/apps/email/label/:label',
    name: 'apps-email-label',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (['personal', 'company', 'important', 'private'].includes(to.params.label)) next()
      else next({ name: 'error-404' })
    },
  },
]
